import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["open", "onClose", "initialFocus", "__demoMode"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import d, { createContext as ae, createRef as se, useContext as V, useEffect as L, useMemo as h, useReducer as pe, useRef as _, useState as de } from "react";
import { match as w } from "../../utils/match.js";
import { forwardRefWithAs as v, render as A, Features as K } from "../../utils/render.js";
import { useSyncRefs as E } from "../../hooks/use-sync-refs.js";
import { Keys as ue } from "../keyboard.js";
import { isDisabledReactIssue7711 as fe } from "../../utils/bugs.js";
import { useId as b } from "../../hooks/use-id.js";
import { FocusTrap as C } from "../../components/focus-trap/focus-trap.js";
import { useInertOthers as ge } from "../../hooks/use-inert-others.js";
import { Portal as I } from "../../components/portal/portal.js";
import { ForcePortalRoot as x } from "../../internal/portal-force-root.js";
import { Description as ce, useDescriptions as Te } from "../description/description.js";
import { useOpenClosed as me, State as q } from "../../internal/open-closed.js";
import { useServerHandoffComplete as De } from "../../hooks/use-server-handoff-complete.js";
import { StackProvider as Pe, StackMessage as z } from "../../internal/stack-context.js";
import { useOutsideClick as ye, Features as Re } from "../../hooks/use-outside-click.js";
import { getOwnerDocument as he } from "../../utils/owner.js";
import { useOwnerDocument as ve } from "../../hooks/use-owner.js";
import { useEventListener as Ae } from "../../hooks/use-event-listener.js";
import { Hidden as Ee, Features as be } from "../../internal/hidden.js";
import { useEvent as k } from "../../hooks/use-event.js";

var Ce = function (o) {
  return o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o;
}(Ce || {}),
    Oe = function (e) {
  return e[e.SetTitleId = 0] = "SetTitleId", e;
}(Oe || {});

var Se = _defineProperty({}, 0, function _(a, e) {
  return a.titleId === e.id ? a : _objectSpread(_objectSpread({}, a), {}, {
    titleId: e.id
  });
}),
    M = ae(null);

M.displayName = "DialogContext";

function O(a) {
  var e = V(M);

  if (e === null) {
    var o = new Error("<".concat(a, " /> is missing a parent <Dialog /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(o, O), o;
  }

  return e;
}

function Fe(a, e) {
  return w(e.type, Se, a, e);
}

var Le = "div",
    we = K.RenderStrategy | K.Static,
    ke = v(function (e, o) {
  var _w;

  var r = e.open,
      n = e.onClose,
      p = e.initialFocus,
      _e$__demoMode = e.__demoMode,
      g = _e$__demoMode === void 0 ? !1 : _e$__demoMode,
      c = _objectWithoutProperties(e, _excluded),
      _de = de(0),
      _de2 = _slicedToArray(_de, 2),
      m = _de2[0],
      D = _de2[1],
      S = me();

  r === void 0 && S !== null && (r = w(S, (_w = {}, _defineProperty(_w, q.Open, !0), _defineProperty(_w, q.Closed, !1), _w)));

  var u = _(new Set()),
      f = _(null),
      J = E(f, o),
      H = _(null),
      P = ve(f),
      W = e.hasOwnProperty("open") || S !== null,
      B = e.hasOwnProperty("onClose");

  if (!W && !B) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!W) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!B) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof r != "boolean") throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(r));
  if (typeof n != "function") throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(n));

  var i = r ? 0 : 1,
      _pe = pe(Fe, {
    titleId: null,
    descriptionId: null,
    panelRef: se()
  }),
      _pe2 = _slicedToArray(_pe, 2),
      y = _pe2[0],
      Q = _pe2[1],
      R = k(function () {
    return n(!1);
  }),
      G = k(function (t) {
    return Q({
      type: 0,
      id: t
    });
  }),
      U = De() ? g ? !1 : i === 0 : !1,
      F = m > 1,
      $ = V(M) !== null,
      X = F ? "parent" : "leaf";

  ge(f, F ? U : !1), ye(function () {
    var l, s;
    return [].concat(_toConsumableArray(Array.from((l = P == null ? void 0 : P.querySelectorAll("body > *")) != null ? l : []).filter(function (T) {
      return !(!(T instanceof HTMLElement) || T.contains(H.current) || y.panelRef.current && T.contains(y.panelRef.current));
    })), [(s = y.panelRef.current) != null ? s : f.current]);
  }, function () {
    i === 0 && (F || R());
  }, Re.IgnoreScrollbars), Ae(P == null ? void 0 : P.defaultView, "keydown", function (t) {
    t.defaultPrevented || t.key === ue.Escape && i === 0 && (F || (t.preventDefault(), t.stopPropagation(), R()));
  }), L(function () {
    var j;
    if (i !== 0 || $) return;
    var t = he(f);
    if (!t) return;
    var l = t.documentElement,
        s = (j = t.defaultView) != null ? j : window,
        T = l.style.overflow,
        le = l.style.paddingRight,
        Y = s.innerWidth - l.clientWidth;

    if (l.style.overflow = "hidden", Y > 0) {
      var ne = l.clientWidth - l.offsetWidth,
          ie = Y - ne;
      l.style.paddingRight = "".concat(ie, "px");
    }

    return function () {
      l.style.overflow = T, l.style.paddingRight = le;
    };
  }, [i, $]), L(function () {
    if (i !== 0 || !f.current) return;
    var t = new IntersectionObserver(function (l) {
      var _iterator = _createForOfIteratorHelper(l),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          s.boundingClientRect.x === 0 && s.boundingClientRect.y === 0 && s.boundingClientRect.width === 0 && s.boundingClientRect.height === 0 && R();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    return t.observe(f.current), function () {
      return t.disconnect();
    };
  }, [i, f, R]);

  var _Te = Te(),
      _Te2 = _slicedToArray(_Te, 2),
      Z = _Te2[0],
      ee = _Te2[1],
      te = "headlessui-dialog-".concat(b()),
      oe = h(function () {
    return [{
      dialogState: i,
      close: R,
      setTitleId: G
    }, y];
  }, [i, y, R, G]),
      N = h(function () {
    return {
      open: i === 0
    };
  }, [i]),
      re = {
    ref: J,
    id: te,
    role: "dialog",
    "aria-modal": i === 0 ? !0 : void 0,
    "aria-labelledby": y.titleId,
    "aria-describedby": Z,
    onClick: function onClick(t) {
      t.stopPropagation();
    }
  };

  return d.createElement(Pe, {
    type: "Dialog",
    element: f,
    onUpdate: k(function (t, l, s) {
      var _w2;

      l === "Dialog" && w(t, (_w2 = {}, _defineProperty(_w2, z.Add, function () {
        u.current.add(s), D(function (T) {
          return T + 1;
        });
      }), _defineProperty(_w2, z.Remove, function () {
        u.current.add(s), D(function (T) {
          return T - 1;
        });
      }), _w2));
    })
  }, d.createElement(x, {
    force: !0
  }, d.createElement(I, null, d.createElement(M.Provider, {
    value: oe
  }, d.createElement(I.Group, {
    target: f
  }, d.createElement(x, {
    force: !1
  }, d.createElement(ee, {
    slot: N,
    name: "Dialog.Description"
  }, d.createElement(C, {
    initialFocus: p,
    containers: u,
    features: U ? w(X, {
      parent: C.features.RestoreFocus,
      leaf: C.features.All & ~C.features.FocusLock
    }) : C.features.None
  }, A({
    ourProps: re,
    theirProps: c,
    slot: N,
    defaultTag: Le,
    features: we,
    visible: i === 0,
    name: "Dialog"
  })))))))), d.createElement(Ee, {
    features: be.Hidden,
    ref: H
  }));
}),
    Me = "div",
    _e = v(function (e, o) {
  var _O = O("Dialog.Overlay"),
      _O2 = _slicedToArray(_O, 1),
      _O2$ = _O2[0],
      r = _O2$.dialogState,
      n = _O2$.close,
      p = E(o),
      g = "headlessui-dialog-overlay-".concat(b()),
      c = k(function (u) {
    if (u.target === u.currentTarget) {
      if (fe(u.currentTarget)) return u.preventDefault();
      u.preventDefault(), u.stopPropagation(), n();
    }
  }),
      m = h(function () {
    return {
      open: r === 0
    };
  }, [r]);

  return A({
    ourProps: {
      ref: p,
      id: g,
      "aria-hidden": !0,
      onClick: c
    },
    theirProps: e,
    slot: m,
    defaultTag: Me,
    name: "Dialog.Overlay"
  });
}),
    Ie = "div",
    xe = v(function (e, o) {
  var _O3 = O("Dialog.Backdrop"),
      _O4 = _slicedToArray(_O3, 2),
      r = _O4[0].dialogState,
      n = _O4[1],
      p = E(o),
      g = "headlessui-dialog-backdrop-".concat(b());

  L(function () {
    if (n.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [n.panelRef]);
  var c = h(function () {
    return {
      open: r === 0
    };
  }, [r]);
  return d.createElement(x, {
    force: !0
  }, d.createElement(I, null, A({
    ourProps: {
      ref: p,
      id: g,
      "aria-hidden": !0
    },
    theirProps: e,
    slot: c,
    defaultTag: Ie,
    name: "Dialog.Backdrop"
  })));
}),
    He = "div",
    We = v(function (e, o) {
  var _O5 = O("Dialog.Panel"),
      _O6 = _slicedToArray(_O5, 2),
      r = _O6[0].dialogState,
      n = _O6[1],
      p = E(o, n.panelRef),
      g = "headlessui-dialog-panel-".concat(b()),
      c = h(function () {
    return {
      open: r === 0
    };
  }, [r]);

  return A({
    ourProps: {
      ref: p,
      id: g
    },
    theirProps: e,
    slot: c,
    defaultTag: He,
    name: "Dialog.Panel"
  });
}),
    Be = "h2",
    Ge = v(function (e, o) {
  var _O7 = O("Dialog.Title"),
      _O8 = _slicedToArray(_O7, 1),
      _O8$ = _O8[0],
      r = _O8$.dialogState,
      n = _O8$.setTitleId,
      p = "headlessui-dialog-title-".concat(b()),
      g = E(o);

  L(function () {
    return n(p), function () {
      return n(null);
    };
  }, [p, n]);
  var c = h(function () {
    return {
      open: r === 0
    };
  }, [r]);
  return A({
    ourProps: {
      ref: g,
      id: p
    },
    theirProps: e,
    slot: c,
    defaultTag: Be,
    name: "Dialog.Title"
  });
}),
    Dt = Object.assign(ke, {
  Backdrop: xe,
  Panel: We,
  Overlay: _e,
  Title: Ge,
  Description: ce
});

export { Dt as Dialog };